import React from "react";
import * as S from "./styles";

import { ReactComponent as Logo } from '../../../../assets/images/business/b_m_cnt7_logo.svg';

type SliderProps = {
    children?: JSX.Element[]
    activeIndex: number
}

type ItemProps = {
    rowNumber?: number
    position?: number
    title: string
    text: string
    image: string
    onClick?: React.MouseEventHandler<HTMLElement>
}

export const Slider = ({children, activeIndex}: SliderProps) => {

    const items = React.Children.map(children, (child, idx) => {
        if (React.isValidElement(child)) {
            const props = {position: activeIndex, rowNumber: idx};
            return React.cloneElement(child, props);
        }
        return child;
    });

    return (
        <S.Slider>
            {items}
        </S.Slider>
    )
}

export const SliderItem = ({rowNumber, position, title, text, image, onClick}: ItemProps) => {
    return (
        <S.SliderItem rowNumber={rowNumber} position={position} image={image} onClick={onClick}>
            <S.SliderContent>
                <S.SliderItemTitle>{title}</S.SliderItemTitle>
                <S.SliderItemText>{text}</S.SliderItemText>
                <S.SliderItemLogo>
                    <Logo/>
                </S.SliderItemLogo>
            </S.SliderContent>
        </S.SliderItem>
    );
}